<template>
  <div class="rodape">
    <div class="p"><p>Copyright LEFISC - Legislação Fiscal - Todos os Direitos Reservados</p></div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
    .rodape {
        position:relative;
        text-align: center;
        width:100%;
        height: 60px;
        background: #fff;
        
    }
    .rodape .p p {
    color: #000;
    position:relative;
    width: 100%;
    margin: 0 auto;
    padding-top: 20px;
    background: #fff;
    font-size: 16px;
    }
</style>